// Models
import { CrewdlePeerConnection } from 'src/app/models/peer-connection/crewdle-peer-connection';
import { PeerStats } from 'src/app/models/peer-stats/peer-stats';
import { PeerStatsParticipant } from 'src/app/models/peer-stats/peer-stats-participant';

// Services
import { ParticipantsListService } from '../participants-list/participants-list.service';

import { StatsParser } from './stats-parser';

export class StatsCollector {
  constructor(
    private participants: ParticipantsListService,
    private statsParser: StatsParser,
  ) {}

  async getStats(
    participantId: string,
    pc: CrewdlePeerConnection,
    report: PeerStats,
    userId: string,
    shareVideoTrackId: string,
    shareAudioTrackId: string,
  ): Promise<void> {
    const senderFilter = [
      'outbound-rtp',
      'remote-inbound-rtp',
    ];
    const senders = pc.getSenders();
    for (const sender of senders) {
      if (sender.track) {
        if (this.participants.participants[participantId].tracks.find((s) => s.track && s.track.id === sender.track.id)) {
          const stats = await sender.getStats();
          stats.forEach((stat) => {
            if (senderFilter.includes(stat.type)) {
              this.statsParser.parse(participantId, stat, report);
            }
          });
        }
        if (this.participants.participants[userId].isSharing && [shareVideoTrackId, shareAudioTrackId].includes(sender.track.id)) {
          if (!report.shareStats[participantId]) {
            report.shareStats[participantId] = new PeerStatsParticipant(participantId);
          }
          const stats = await sender.getStats();
          stats.forEach((stat) => {
            if (senderFilter.includes(stat.type)) {
              this.statsParser.parse(participantId, stat, report, true);
            }
          });
        }
      }
    }

    const receiverFilter = [
      'inbound-rtp',
    ];
    const receivers = pc.getReceivers();
    for (const receiver of receivers) {
      if (receiver.track) {
        if (this.participants.participants[participantId].stream.getTracks().find((track) => track.id === receiver.track.id)) {
          const stats = await receiver.getStats();
          stats.forEach((stat) => {
            if (receiverFilter.includes(stat.type)) {
              this.statsParser.parse(participantId, stat, report);
            }
          });
        }
        if (this.participants.participants[participantId].isSharing && [shareVideoTrackId, shareAudioTrackId].includes(receiver.track.id)) {
          if (!report.shareStats[participantId]) {
            report.shareStats[participantId] = new PeerStatsParticipant(participantId);
          }
          const stats = await receiver.getStats();
          stats.forEach((stat) => {
            if (receiverFilter.includes(stat.type)) {
              this.statsParser.parse(participantId, stat, report, true);
            }
          });
        }
      }
    }

    if (
      !this.participants.participants[userId].isSharing &&
      !this.participants.participants[participantId].isSharing &&
      report.shareStats[participantId]
    ) {
      delete report.shareStats[participantId];
    }
  }
}
